module.exports = __webpack_public_path__ + "img/red_bg.0fe5bbde.png";